let notificationsHubApiSingleton = null;
export function setNotificationsHubApi(api) {
    notificationsHubApiSingleton = api;
}
export function getNotificationsHubApi() {
    return notificationsHubApiSingleton;
}
